import { useEffect, useState } from 'react'
import { db } from '@core/db/db'
import { syncService } from '@core/services/sync/SyncService'
import { CategoryGlyph } from './CategoryGlyph'

export interface CategoryImageProps {
  name: string
  /** Есть ли загруженная картинка (флаг из облака). */
  hasImage?: boolean
  size?: number
  className?: string
  rounded?: number
}

/**
 * Картинка категории: загруженная из кэша/облака или сгенерированный глиф.
 * Объектный URL создаётся и освобождается на каждый asset.
 */
export function CategoryImage({
  name,
  hasImage,
  size = 40,
  className,
  rounded
}: CategoryImageProps) {
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    let objectUrl: string | null = null

    if (!hasImage) {
      setUrl(null)
      return
    }

    void (async () => {
      const key = `category:${name}`
      let asset = await db.assets.where('key').equals(key).first()
      if (!asset) {
        const fetched = await syncService
          .fetchCategoryImage(name)
          .catch(() => false)
        if (fetched) {
          asset = await db.assets.where('key').equals(key).first()
        }
      }
      if (cancelled || !asset) return
      objectUrl = URL.createObjectURL(asset.blob)
      setUrl(objectUrl)
    })()

    return () => {
      cancelled = true
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [name, hasImage])

  if (url) {
    return (
      <img
        src={url}
        alt=""
        width={size}
        height={size}
        className={`rounded-md object-cover ${className ?? ''}`}
        style={{ width: size, height: size }}
      />
    )
  }

  return (
    <CategoryGlyph
      name={name}
      size={size}
      className={className}
      rounded={rounded}
    />
  )
}
